<template>
  <div class="grid-container mbot">
    <div class="grid-x grid-padding-x grid-margin-x grid-margin-y">
      <div class="cell small-order-2 large-order-1">
        <div class="suche-wrapper">
          <label for="suche" aria-label="Nach Angeboten suchen">
            <svg class="icon-search" xmlns="http://www.w3.org/2000/svg" width="40.066" height="28.947" viewBox="0 0 40.066 28.947">
              <g transform="translate(3776.082 4014.509)">
                <g>
                  <path class="stroke-akz1" d="M-3741.925-4010.862s-.423,7.524,0,8.655" fill="none" stroke-linecap="round" stroke-width="3"/>
                  <path class="stroke-akz1" d="M-3741.925-4010.862s-.423,7.524,0,8.655" transform="translate(-7748.459 -264.421) rotate(90)" fill="none" stroke-linecap="round" stroke-width="3"/>
                </g>
                <g>
                  <path class="stroke-wht" d="M-3765.276-4013c-4.7.222-8.38.993-9.216,7.407s4.734,8.777,9.216,8.973,9.855-2.316,9.732-6.947S-3760.574-4013.222-3765.276-4013Z" fill="none" stroke-width="3"/>
                </g>
                <path class="stroke-wht" d="M-3759.564-3996.609s12.044,7.52,13.528,11.085" transform="translate(1.022 -2)" fill="none" stroke-linecap="round" stroke-width="3"/>
              </g>
            </svg>
          </label>
          <input type="text" id="suche" class="suche" placeholder="Suche" v-model="searchInput" />
        </div>
      </div>
      <div class="cell small-order-1 large-order-2">
        <h3 class="h2 filter-h2">Filtern:</h3>
        <div class="filter-grid">
          <div class="filter-box">
            <label class="select-filter filter-box_label" for="angebotsart">Angebotsart</label>
            <select
              class="reset select-filter filter-box_select"
              name="angebotsart"
              id="angebotsart"
              v-model="selectedCategory"
            >
              <option class="no-select" value="" selected="selected"> -- Option wählen -- </option>
              <option :value="category" v-for="category in availableCategories">
                {{ category }}
              </option>
            </select>
          </div>
          <div class="filter-box">
            <label class="select-filter filter-box_label" for="zielgruppe">Zielgruppe</label>
            <select
              class="reset select-filter filter-box_select"
              name="zielgruppe"
              id="zielgruppe"
              v-model="selectedZielgruppe"
            >
              <option class="no-select" value="" selected="selected"> -- Option wählen -- </option>
              <option :value="zielgruppe" v-for="zielgruppe in availableZielgruppen">{{ zielgruppe }}</option>
            </select>
          </div>
          <div class="filter-box">
            <label class="select-filter filter-box_label" for="wochentag">Wochentag</label>
            <select
              class="reset select-filter filter-box_select"
              name="wochentag"
              id="wochentag"
              v-model="selectedWochentag"
            >
              <option class="no-select" value="" selected="selected"> -- Option wählen -- </option>
              <option :value="wochentag" v-for="wochentag in availableWochentage">{{ wochentag }}</option>
            </select>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="grid-container news-teaser-wrapper bg-waves">
    <div class="grid-x grid-margin-x grid-padding-x grid-padding-y kurs-content">
      <div class="cell">
        <div class="kurs-teaser cl3-grid">
          <article class="teaser-item" v-for="kurs in filteredList">
            <div class="teaser-image ratio_3-2">
              <a class="noani" :href="removeJsonSuffix(kurs.nodeUri)">
                <img
                  v-if="kurs.kursFields.kursImage"
                  class="projekte-grid_item_image"
                  :src="kurs.kursFields.kursImage"
                  alt=""
                />
              </a>
            </div>
            <div class="teaser-content">
              <h2 v-html="kurs.kursFields.kursTitel"></h2>
              <span v-html="formatCommaList(kurs.kursFields.kursZielgruppe)" class="zg"></span>
              <span v-html="formatCommaList(kurs.kursFields.kursCategories)" class="zg"></span>
              <span v-html="formatWochentage(kurs.kursFields.kursWochentag)" class="zg"></span>
              <div v-html="kurs.kursFields.kursText"></div>
            </div>
            <div class="teaser-button">
              <a :href="removeJsonSuffix(kurs.nodeUri)" class="button-link">Details</a>
            </div>
          </article>
        </div>
        <div style="width: 100%; text-align: center" v-if="loading">
          <span class="loader"></span>
        </div>
        <div
          style="width: 100%; text-align: center"
          v-if="filteredList.length === 0 && loading == false"
        >
          <p class="mbot">Kein Projekt mit diesen Filtern gefunden</p>

          <!-- Reset Filter button -->
          <button
            class="button-link"
            @click="
              searchInput = '';
              selectedCategory = '';
              selectedZielgruppe = '';
              selectedWochentag = '';
            "
          >
            Alle Filter zurücksetzen
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
//import JSONData from "../assets/data.json";
export default {
  name: "ProjekteListing",
  components: {},
  data() {
    return {
      kurse: [],
      kursCategories: [],
      kursZielgruppen: [],
      kursWochentage: [],
      searchInput: "",
      selectedCategory: "",
      selectedZielgruppe: "",
      selectedWochentag: "",

      loading: true, // Loadingstate
    };
  },
  mounted() {
    this.getKurse();
  },
  computed: {
    filteredList() {
      return this.kurse.filter((kurs) => {
        if (
          this.selectedCategory &&
          !kurs.kursFields.kursCategories.map(c => c.trim().toLowerCase()).includes(this.selectedCategory.trim().toLowerCase())
        )
          return false;

        if (
          this.selectedZielgruppe &&
          !kurs.kursFields.kursZielgruppe.map(z => z.trim().toLowerCase()).includes(this.selectedZielgruppe.trim().toLowerCase())
        )
          return false;

        if (
          this.selectedWochentag &&
          !kurs.kursFields.kursWochentag.map(w => w.trim().toLowerCase()).includes(this.selectedWochentag.trim().toLowerCase())
        )
          return false;

        const search = this.searchInput.toLowerCase();
        return kurs.kursFields.kursTitel.toLowerCase().includes(search) ||
          kurs.kursFields.kursText.toLowerCase().includes(search);
      });
    },

    availableCategories() {
      return this.removeDuplicates(
        this.kurse
          .filter((kurs) => {
            if (
              this.selectedZielgruppe &&
              !kurs.kursFields.kursZielgruppe.map(z => z.trim().toLowerCase()).includes(this.selectedZielgruppe.trim().toLowerCase())
            )
              return false;

            if (
              this.selectedWochentag &&
              !kurs.kursFields.kursWochentag.map(w => w.trim().toLowerCase()).includes(this.selectedWochentag.trim().toLowerCase())
            )
              return false;

            return true;
          })
          .flatMap((kurs) => kurs.kursFields.kursCategories)
      );
    },

    availableZielgruppen() {
      return this.removeDuplicates(
        this.kurse
          .filter((kurs) => {
            if (
              this.selectedCategory &&
              !kurs.kursFields.kursCategories.map(c => c.trim().toLowerCase()).includes(this.selectedCategory.trim().toLowerCase())
            )
              return false;

            if (
              this.selectedWochentag &&
              !kurs.kursFields.kursWochentag.map(w => w.trim().toLowerCase()).includes(this.selectedWochentag.trim().toLowerCase())
            )
              return false;

            return true;
          })
          .flatMap((kurs) => kurs.kursFields.kursZielgruppe)
      );
    },

    availableWochentage() {
      const wochentagOrder = ['Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag', 'Sonntag'];
      const tage = this.removeDuplicates(
        this.kurse
          .filter((kurs) => {
            if (
              this.selectedCategory &&
              !kurs.kursFields.kursCategories.map(c => c.trim().toLowerCase()).includes(this.selectedCategory.trim().toLowerCase())
            )
              return false;

            if (
              this.selectedZielgruppe &&
              !kurs.kursFields.kursZielgruppe.map(z => z.trim().toLowerCase()).includes(this.selectedZielgruppe.trim().toLowerCase())
            )
              return false;

            return true;
          })
          .flatMap((kurs) => kurs.kursFields.kursWochentag)
      );
      return tage.sort((a, b) => wochentagOrder.indexOf(a) - wochentagOrder.indexOf(b));
    },
  },

  methods: {
    getKurse() {
      //! Use the JSON data from the JSON file
      //this.kurse = JSONData.childPages;
      //this.loading = false;

      //! Use the JSON data from the API
      const kurseUrl =
        window.location.hostname === "localhost"
          ? "http://localhost:8081/kurse.json"
          : "https://www.tzpz-oyten.de/kurse.json";

      axios
        .get(kurseUrl) // Projektdaten der NUE
        .then((response) => {
          this.kurse = response.data.childPages;
          this.getFilterCategories();
          this.getFilterZielgruppen();
          this.getFilterWochentage();
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getFilterCategories() {
      const categories = this.kurse.flatMap((kurs) => {
        return kurs.kursFields.kursCategories;
      });

      this.kursCategories = this.removeDuplicates(categories);
    },

    getFilterZielgruppen() {
      const zielgruppen = this.kurse.flatMap((kurs) => {
        return kurs.kursFields.kursZielgruppe;
      });
      this.kursZielgruppen = this.removeDuplicates(zielgruppen);
    },

    getFilterWochentage() {
      const wochentage = this.kurse.flatMap((kurs) => {
        return kurs.kursFields.kursWochentag;
      });
      this.kursWochentage = this.removeDuplicates(wochentage);
    },

    // utility functions remove whitespace and sort alphabetically and compare lowercase if already exists
    removeDuplicates(array) {
      return this.sortArray(array).filter((item, index, self) => {
        return (
          item.trim() !== "" &&
          self.indexOf(item) === index && item.trim().toLowerCase() === item.toLowerCase()
        );
      });
    },

    // sort the array alphabetically
    sortArray(array) {
      return array.sort();
    },

    // remove the .json suffix from the URL
    removeJsonSuffix(url) {
      return url.replace(".json", "");
    },

    formatWochentage(wochentage) {
      if (!wochentage) return "";
      const arr = Array.isArray(wochentage) ? wochentage : String(wochentage).split(",");
      return arr
        .map((tag) => tag.trim().substring(0, 2))
        .filter((tag) => tag !== "")
        .join(", ");
    },

    formatCommaList(value) {
      if (!value) return "";
      const arr = Array.isArray(value) ? value : String(value).split(",");
      return arr
        .map((item) => item.trim())
        .filter((item) => item !== "")
        .join(", ");
    },
  },
};
</script>
